//
//

import { mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQTreeConfig from "@/components/Generics/TreeConfiguration/AQTreeConfig.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { copyToClipboard } from "@/assets/js/appFunc";

export default {
    name: "MethodsModal",
    components: { AQModal, AQCard, AQInput, AQTreeConfig, AQButton },
    props: {
        methodsModalData: { type: Object, default: () => {} }
    },
    data() {
        return {
            showMethodsDlg: true,
            hideDMPicker: true,
            methodsTabsConfiguration: "request"
        };
    },
    computed: {
        ...mapGetters("diagrams", ["setAllResponse", "setAllRequest"]),
        methodsModalTitle() {
            return `"${this.methodsModalData.method}" ${this.$t("api.methodsModalTitle")}` || "";
        }
    },

    methods: {
        copyURL(item) {
            copyToClipboard(item, `${this.$t("api.internalUrlCard")}${this.$t("admin.authentication.copyToClipboardCustomMsg")}`);
        },
        actionsDlg() {
            this.showMethodsDlg = false;
            this.$emit("input", false);
        }
    }
};
